
<section class="printme" id="printme">
  <div id="invoicecontent" class="invoice-content">
    <div>
      <div class="row">
        <div class="col-md-6 mb-5">
          <img src="./assets/img/zero/logo/czlogo.svg">
        </div>
        <div class="col-md-6 mb-5">
          <!--div class="preview-title">{{invoicetype[x.type]}}</div-->
          <div class="text-right">
            <div><b>CODEZERO SDN BHD <small>(1247905-T)</small></b></div>
            <div>NO 18-3, JALAN PJU 8/5C, <br/>DAMANSARA PERDANA, <br/>47820 PETALING JAYA, SELANGOR</div>
            <div>hello@codezero.app</div>
          </div>
        </div>
      </div>
      <div class="text-left mb-4">
        <div class="preview-title">{{ pdftitle }}</div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-4">
          <div>
            <div><b>Bill To:</b></div>
            <div class="font-18">{{ regname }}</div>
            <div>{{ address }}</div>
            <div>{{ email }}</div>
            <div>{{ tel }}</div>
          </div>
        </div>
        <div class="col-md-6 mb-4 text-right">
          <div class="mb-1">
            <!--div class="col-6"><b>{{invoicetype[x.type]}} No.:</b></div-->
            <div><b>{{ pdftitle }} Number:</b></div>
            <div>{{x.no}}</div>
          </div>
          <div *ngIf="x.type == 1">
            <div class="mb-1">
              <div><b>Date:</b></div>
              <div>{{parseDate(this.x.dt_created,'d/M/yyyy')}}</div>
            </div>
          </div>
          <div *ngIf="x.type == 2">
            <div class="mb-1">
              <div><b>Date Paid:</b></div>
              <div>{{this.payment.dt_received?parseDate(this.payment.dt_received,'d/M/yyyy'):parseDate(x.dt_paid,'d/M/yyyy')}}</div>
            </div>
            <div>
              <div><b>Payment Method:</b></div>
              <div>{{this.payment.paymenthod?this.payment.paymenthod:'-'}}</div>
            </div>
          </div>
        </div>
      </div>
      <!--div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="2" scope="col">BILL TO</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style="width:30%"><b>COMPANY NAME</b></td>
              <td style="width:70%">{{ regname }}</td>
            </tr>
            <tr>
              <td style="width:30%"><b>COMPANY ADDRESS</b></td>
              <td style="width:70%">{{ address }}</td>
            </tr>
            <tr>
              <td style="width:30%"><b>EMAIL ADDRESS</b></td>
              <td style="width:70%">{{ email }}</td>
            </tr>
            <tr>
              <td style="width:30%"><b>CONTACT NO.</b></td>
              <td style="width:70%">{{ tel }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br/-->

      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">DATE</th>
              <th scope="col">PLAN</th>
              <th scope="col">AMOUNT (US$)</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style="20%">{{parseDate(x.start_date,'d MMMM yyyy')}} - {{parseDate(x.end_date,'d MMMM yyyy')}}</td>
              <td style="30&">{{x.name}} - {{ptypename[x.packagetype]}}</td>
              <td style="10%">{{x.amount}}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td colspan="2" class="text-right"><strong>Total</strong></td>
              <td>{{x.amount}}</td>
            </tr>
            <!--tr>
              <td colspan="2" class="text-right"><strong>Total in MYR</strong></td>
              <td>MYR 2078.25</td>
            </tr -->
            <tr *ngIf="x.prorate>0">
              <td colspan="2" class="text-right"><b>Prorating Adjustment</b></td>
              <td>({{x.prorate}})</td>
            </tr>
            <tr *ngIf="x.extra>0">
              <td colspan="2" class="text-right"><b>Renewed Adjustment ({{x.noofmonth}} months)</b></td>
              <td>{{x.extra}}</td>
            </tr>
            <tr *ngIf="x.credit>0">
              <td colspan="2" class="text-right"><b>Credit</b></td>
              <td>({{x.extra}})</td>
            </tr>
            <tr *ngIf="x.type == 1">
              <td colspan="2" class="text-right font-20"><b>Balance Due</b></td>
              <td class="font-20"><b>US${{x.amount}}</b></td>
            </tr>
            <!--tr *ngIf="x.type == 1">
              <td colspan="2" class="text-right font-20"><b>Balance Due</b></td>
              <td class="font-20"><b>MYR 2078.25</b></td>
            </tr -->
            <tr *ngIf="x.type == 2">
              <td colspan="2" class="text-right font-20"><b>Payment Received</b></td>
              <td class="font-20"><b>US${{x.payamount}}</b></td>
            </tr>
          </tfoot>
        </table>
        <!--div class="end-notes1">
          <div class="mb-3">
            <div>
              Terms of Payment:
              <p>Payments via cheque or bank transfer should be made to <b>CODEZERO SDN BHD</b>
              <br/>CIMB Bank account number : <b>800 8926 323</b>
              </p> 
            </div>
          </div>
      </div -->
    </div>
  </div>

  
   
  </div>

  

  <div class="end-notes" *ngIf="x.type == 2">
    <div class="text-center mb-3">
      <div>
        This receipt confirms payment for the subscription plan listed above. If you have any questions about your bill, contact hello@codezero.app.
      </div>
    </div>
    <div class="text-right">
      <div><small>Page 1 of 1</small></div>
    </div>
  </div>
</section>
